import authBehavior from 'app/beta-editor/pages/behaviors/auth';
import createTemplateBehavior from 'app/beta-editor/pages/behaviors/createTemplate';
import fieldsBehavior from 'app/beta-editor/pages/behaviors/fields';
import filterBehavior from 'app/beta-editor/pages/behaviors/filter';
import overviewBehavior from 'app/beta-editor/pages/behaviors/overview';
import pathRulesBehavior from 'app/beta-editor/pages/behaviors/pathRules';
import pathSettingsBehavior from 'app/beta-editor/pages/behaviors/pathSettings';
import sampleBehavior from 'app/beta-editor/pages/behaviors/sample';
import setupBehavior from 'app/beta-editor/pages/behaviors/setup';
import webhookBehavior from 'app/beta-editor/pages/behaviors/webhook';
import welcomeBehavior from 'app/beta-editor/pages/behaviors/welcome';
import { PATH_SETTINGS_PAGE } from 'app/beta-editor/constants';

import { FlowPageKey } from 'app/beta-editor/types';

import { Behavior, RequiredBehaviors } from './types';

type PageBehaviorEntry = { behavior: Behavior };

type PageBehaviorsMap = { [K in FlowPageKey]?: PageBehaviorEntry };

const defaultBehavior = {
  isLoading: () => false,
};

const supplyDefaults = (behavior: RequiredBehaviors) => ({
  ...defaultBehavior,
  ...behavior,
});

const pageBehaviorsMap: PageBehaviorsMap = {
  setup: { behavior: supplyDefaults(setupBehavior) },
  auth: { behavior: supplyDefaults(authBehavior) },
  webhook: { behavior: supplyDefaults(webhookBehavior) },
  fields: { behavior: supplyDefaults(fieldsBehavior) },
  filter: { behavior: supplyDefaults(filterBehavior) },
  [PATH_SETTINGS_PAGE]: { behavior: supplyDefaults(pathSettingsBehavior) },
  rules: { behavior: supplyDefaults(pathRulesBehavior) },
  sample: { behavior: supplyDefaults(sampleBehavior) },
  __create_template: { behavior: supplyDefaults(createTemplateBehavior) },
  overview: { behavior: supplyDefaults(overviewBehavior) },
  welcome: { behavior: supplyDefaults(welcomeBehavior) },
};

export default pageBehaviorsMap;
